import React from 'react';
import { AlertTriangle, Inbox } from 'lucide-react';
import './CrmFeedbackState.css';

export interface CrmFeedbackStateProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  actionLabel?: React.ReactNode;
  onAction?: () => void;
  actionDisabled?: boolean;
  size?: 'compact' | 'default';
  className?: string;
}

function FeedbackState({ title, description, icon, actionLabel, onAction, actionDisabled = false, size = 'default', className = '', error = false }: CrmFeedbackStateProps & { error?: boolean }) {
  return <section className={`crm-feedback-state crm-feedback-state--${size} ${className}`} role={error ? 'alert' : undefined}>
    <span className="crm-feedback-state__icon" aria-hidden="true">{icon ?? (error ? <AlertTriangle size={24} /> : <Inbox size={24} />)}</span>
    <h2>{title}</h2>
    {description && <p>{description}</p>}
    {actionLabel && onAction && <button type="button" onClick={onAction} disabled={actionDisabled}>{actionLabel}</button>}
  </section>;
}

export function CrmEmptyState(props: CrmFeedbackStateProps) { return <FeedbackState {...props} />; }
export function CrmErrorState(props: CrmFeedbackStateProps) { return <FeedbackState {...props} error />; }
